import { gql } from "@apollo/client";

const UPDATE_COMPANY_INFO = gql`
  mutation UpdateCompanyInfo($companyInfo: CompanyInfoUpdate!) {
    updateCompanyInfo(companyInfo: $companyInfo) {
      id
    }
  }
`;
const UPDATE_COMPANY_INFO_STATUS = gql`
  mutation UpdateCompanyInfo(
    $approval: CompanyApprovalStatusUpdate
    $companyInfo: CompanyInfoUpdate!
  ) {
    updateCompanyInfo(approval: $approval, companyInfo: $companyInfo) {
      id
    }
  }
`;

const ADMIN_UPDATE_COMPANY_INFO = gql`
  mutation AdminUpdateCompanyProfile(
    $adminUpdateCompanyProfileId: ID!
    $approval: CompanyApprovalStatus
    $comission: Float
    $comissionHoldingFee: Float
    $commissionPaidByUser: Boolean
    $isAutoInvoice: Boolean
    $invoiceSeries: String
    $invoiceNumber: Float
    $companyInfo: CompanyInfoUpdate
  ) {
    adminUpdateCompanyProfile(
      id: $adminUpdateCompanyProfileId
      approval: $approval
      comission: $comission
      comissionHoldingFee: $comissionHoldingFee
      commissionPaidByUser: $commissionPaidByUser
      isAutoInvoice: $isAutoInvoice
      invoiceSeries: $invoiceSeries
      invoiceNumber: $invoiceNumber
      companyInfo: $companyInfo
    ) {
      approval
      comission
      comissionHoldingFee
      commissionPaidByUser
      isAutoInvoice
    }
  }
`;

const GET_COMPANIES_INFO = gql`
  query CompanyInfo {
    companies {
      companyInfo {
        companyName
      }
      id
    }
  }
`;

const SET_COMPANY_BT_CREDENTIALS_ENABLED = gql`
  mutation SetCompanyBtCredentialsEnabled($companyId: ID!, $enabled: Boolean!) {
    setCompanyBtCredentialsEnabled(companyId: $companyId, enabled: $enabled)
  }
`;

const SET_COMPANY_SMS_BOOKING_CONFIRMATION = gql`
  mutation SetCompanySmsBookingConfirmation($companyId: ID!, $enabled: Boolean!) {
    setCompanySmsBookingConfirmation(companyId: $companyId, enabled: $enabled)
  }
`;

export {
  UPDATE_COMPANY_INFO,
  ADMIN_UPDATE_COMPANY_INFO,
  UPDATE_COMPANY_INFO_STATUS,
  GET_COMPANIES_INFO,
  SET_COMPANY_BT_CREDENTIALS_ENABLED,
  SET_COMPANY_SMS_BOOKING_CONFIRMATION
};
